jQuery(document).ready(function () {
    var config = document.getElementById('player-config');
    if (!config) {
        return;
    }
    var streamUrl = config.getAttribute('data-stream-url');
    var playlistUrl = config.getAttribute('data-playlist-url');
    var channel = config.getAttribute('data-channel');
    // All three configs are required - set by these TypoScript constants:
    // general.player.channel
    // general.player.streamUrl
    // general.player.playlistUrl
    if (!streamUrl || !playlistUrl || !channel) {
        return;
    }
    var volume = 0.5;
    var $playButton = jQuery('.jp-play');
    var $stopButton = jQuery('.jp-stop');
    var $incrVolumeButton = jQuery('.jp-increase-vol');
    var $decrVolumeButton = jQuery('.jp-decrease-vol');
    var $player = jQuery('#jquery_jplayer_1');

    $player.jPlayer({
        supplied: 'mp3',
        wmode: 'window',
        useStateClassSkin: true,
        autoBlur: false,
        smoothPlayBar: true,
        keyEnabled: true,
        remainingDuration: true,
        toggleDuration: true,
        volume: volume
    });

    // Crossplan integration:
    // DMP listener hook. Crossplan was told the event name is "ffnRadioStreamPlay"
    // and reads detail.channel. Do not rename without coordinating with Crossplan.
    $player.on(jQuery.jPlayer.event.play, function () {
        window.dispatchEvent(new CustomEvent('ffnRadioStreamPlay', {
            detail: { channel: channel }
        }));
    });

    $stopButton.on('click', function () {
        $player.jPlayer('stop');
    });

    $decrVolumeButton.on('click', function () {
        if (volume > 0.1) { volume -= 0.1; }
        $player.jPlayer('volume', volume);
    });

    $incrVolumeButton.on('click', function () {
        if (volume < 0.9) { volume += 0.1; }
        $player.jPlayer('volume', volume);
    });

    // Crossplan integration: cpd_configdata.url is "filled successively" by the
    // CPT (per Crossplan docs, shared/crossplan.md step 4), so it is typically
    // not ready when jPlayer initialises. We defer setMedia until either the
    // required ad params arrive or a hard deadline elapses, then call setMedia
    // exactly once. Goal: the stream is fetched exactly once — with ad params
    // on the fast/normal path, on the bare URL only after the deadline (no
    // consent / adblocker / slow CPT).
    //
    // Readiness requires BOTH `listenerid=` (AdsWizz Listener Identifier) and
    // `aw_0_req.userConsentV2=` (TCF Consent String) in cpd_configdata.url —
    // the two keys Crossplan names as required. CPT appends them successively
    // with no documented ordering, so waiting for "url is truthy" or only one
    // of the two would race: the URL handed to setMedia might be missing the
    // other key. Adblocker / no-TCF users don't get cpd_configdata populated
    // at all and are caught by the deadline → bare URL fallback, not by
    // relaxing this gate.
    var STREAM_URL_DEADLINE_MS = 3000;
    var STREAM_URL_POLL_MS = 100;
    var streamUrlDeadline = +(new Date()) + STREAM_URL_DEADLINE_MS;
    var streamUrlSet = false;
    var streamUrlPollTimer = null;

    // We need to ensure both arguments 'listenerid' and 'aw_0_req.userConsentV2'
    // will be appended when consent is given.
    function hasRequiredAdParams() {
        var url = window.cpd_configdata && window.cpd_configdata.url;
        if (!url) {
            return false;
        }
        return url.indexOf('listenerid=') !== -1
            && url.indexOf('aw_0_req.userConsentV2=') !== -1;
    }

    function trySetStreamUrl() {
        if (streamUrlSet) {
            return;
        }
        var ready = hasRequiredAdParams();
        var deadlineHit = +(new Date()) >= streamUrlDeadline;
        if (!ready && !deadlineHit) {
            return;
        }
        // Deadline-hit without ready params: cpd_configdata.url may be a
        // partial string missing listenerid — use the bare URL rather than
        // half-enriching it.
        $player.jPlayer('setMedia', { mp3: ready ? buildStreamUrl() : streamUrl });
        streamUrlSet = true;
        $playButton.removeClass('is-loading').removeAttr('disabled');
        if (streamUrlPollTimer !== null) {
            clearInterval(streamUrlPollTimer);
            streamUrlPollTimer = null;
        }
    }

    // Crossplan integration (publisher-integration-web, step 4):
    // The CPT (Crossplan Tag, loaded via GTM) collects ad-relevant parameters in
    // window.cpd_configdata.url. We append that parameter string to the stream URL
    // so the adserver receives listenerid + aw_0_req.userConsentV2.
    // Per Crossplan docs the appending must be conditional — without consent (e.g.
    // adblocker, no TCF opt-in) cpd_configdata is absent and the player must
    // still work on the bare stream URL.
    function buildStreamUrl() {
        var adParams = (window.cpd_configdata && window.cpd_configdata.url) || '';
        if (!adParams) {
            return streamUrl;
        }
        if (adParams.charAt(0) === '?' || adParams.charAt(0) === '&') {
            adParams = adParams.substring(1);
        }
        return streamUrl + (streamUrl.indexOf('?') === -1 ? '?' : '&') + adParams;
    }

    function loadArtistInformation() {
        jQuery.ajax({
            type: 'GET',
            dataType: 'json',
            url: playlistUrl,
            success: function (responseData, textStatus, jqXHR) {
                // first item of songs[] is the previous song - here we want the current song
                if (responseData.songs && responseData.songs.length > 1) {
                    jQuery('[data-player="artist"]').text(responseData.songs[1].artist);
                    jQuery('[data-player="title"]').text(responseData.songs[1].title);
                }
            },
            error: function (responseData, textStatus, errorThrown) {
                console.error('Error:', responseData, textStatus, errorThrown);
            }
        });
    }

    $playButton.addClass('is-loading').attr('disabled', 'disabled');
    trySetStreamUrl();
    if (!streamUrlSet) {
        streamUrlPollTimer = setInterval(trySetStreamUrl, STREAM_URL_POLL_MS);
    }

    loadArtistInformation();
    setInterval(loadArtistInformation, 10000);
});
